// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"6c7ae2c3","564":"66187a6d"}[chunkId] + ".chunk.css";
};